/*global _, $ */
import {randomMinMax} from './utils'
import confetti from 'canvas-confetti'

const filterOpts = (opts) => {
  return _.pick(opts, [
    'particleCount',
    'angle',
    'spread',
    'startVelocity',
    'decay',
    'gravity',
    'drift',
    'ticks',
    'origin',
    'colors',
    'shapes',
    'scalar',
    'zIndex',
    'disableForReducedMotion',
  ])
}
const disableForReducedMotion = false

const exportDefault = {
  fire: {}
}

export const destroy = exportDefault.destroy = (customConfetti) => {
  customConfetti = customConfetti || confetti
  customConfetti.reset()
  return customConfetti
}

export const fire = exportDefault.confetti = (opts, customConfetti) => {
  opts = opts || {}
  const defaults = {
    disableForReducedMotion
  }

  customConfetti = customConfetti || confetti
  const options = filterOpts(Object.assign({}, defaults, opts))
  customConfetti(options)
  return customConfetti
}

export const fireRandom = exportDefault.fire.random = (count, opts, customConfetti) => {
  const defaults = {
    particleCount: count || randomMinMax(40, 400),
    angle: randomMinMax(0, 360),
    spread: randomMinMax(40, 360),
    startVelocity: randomMinMax(40, 80),
    // decay: randomMinMax(0, 1.1),
    // gravity: randomMinMax(-.5, 1),
    // drift: randomMinMax(-1, 1),
    // ticks: randomMinMax(100, 300),
    origin: {
      x: randomMinMax(0, 1),
      y: randomMinMax(0, 1)
    },
    scalar: randomMinMax(1, 2)
  }
  opts = _.merge({}, defaults, opts || {})
  return fire(opts, customConfetti)
}

export const fireworks = exportDefault.fire.fireworks = (count, opts, customConfetti) => {
  if (opts.repeat) {
    if (_.isFunction(opts.repeat)) {
      if (!opts.repeat()) {
        if (_.isFunction(opts.repeatEnd)) {
          opts.repeatEnd()
        }
        return
      }
    }
  }
  count = count || 200
  const defaults = {particleCount: count, startVelocity: 30, spread: 360, ticks: 60};
  opts = _.merge({}, defaults, opts || {})
  fire(opts, customConfetti)
  if (opts.repeat) {
    if (_.isFunction(opts.repeat)) {
      const canRepeat = opts.repeat()
      if (canRepeat) {
        setTimeout(() => {
          fireworks(count, opts, customConfetti)
        }, opts.repeatInterval || 2000)
      } else {
        if (_.isFunction(opts.repeatEnd)) {
          opts.repeatEnd()
        }
      }
    }
  }
  return customConfetti
}

export const fireDefault = exportDefault.fire.default = (count, opts, customConfetti) => {
  count = count || 200
  opts = opts || {}
  fire({
    spread: 26,
    particleCount: Math.floor(count * .25),
    startVelocity: 55,
    ...opts,
  }, customConfetti)

  fire({
    spread: 60,
    particleCount: Math.floor(count * .2),
    ...opts,
  }, customConfetti)
  fire({
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
    particleCount: Math.floor(count * .35),
    ...opts,
  }, customConfetti)
  fire({
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
    particleCount: Math.floor(count * .1),
    ...opts,
  }, customConfetti)
  fire({
    spread: 120,
    startVelocity: 45,
    particleCount: Math.floor(count * .1),
    ...opts,
  }, customConfetti)

  return customConfetti
}

export const custom = exportDefault.custom = (container, fireOptions, options, isPrepend) => {
  options = options || {}
  const customCanvas = document.createElement('canvas')
  const canvasOptions = options.canvas || {}
  const canvasCss = canvasOptions.$css ? canvasOptions.$css :
    _.merge({}, {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  }, canvasOptions.css || {})

  $(customCanvas).css(canvasCss)

  if (isPrepend) {
    $(container).prepend(customCanvas)
  } else {
    $(container).append(customCanvas)
  }
  const customConfetti = confetti.create(customCanvas, {
    disableForReducedMotion,
    useWorker: true,
    resize: true,
    ...(options.confetti || {})
  })

  if (fireOptions) {
    if (_.isString(fireOptions)) {
      const method = exportDefault.fire[fireOptions] || fireDefault
      method(null, null, customConfetti)
    } else if (_.isObject(fireOptions)) {
      const type = fireOptions.type
      const method = exportDefault.fire[type] || fireDefault
      method(null, fireOptions, customConfetti)
    }
  }
  return customConfetti
}

export const fireUntil = exportDefault.fireUntil = async (confetti, check) => {
  if (check()) {
    fireDefault(null, null, confetti)
  }
  setTimeout(() => {
    fireUntil(confetti, check)
  }, 2000)
}

export const confettiBelowModal = exportDefault.confettiBelowModal = async (Bus, event) => {
  Bus.$on(event + '.mounted', async (vm) => {
    let canFire = true
    Bus.$once(event + '.destroyed', () => {
      canFire = false
    })

    await vm.$nextTick()
    const el = vm.$el
    const container = el
    await vm.$nextTick()
    if (canFire) {
      const customConfetti = custom(container, null, {}, true)
      await fireUntil(customConfetti, () => canFire)
    }
  })
}

export const confettiOnMouseEvent = exportDefault.confettiOnMouseEvent = async (mouseEvent) => {
  if (mouseEvent) {
    const count = randomMinMax(50, 200)
    const x = (mouseEvent.pageX - window.scrollX) / $(window).width()
    const y = (mouseEvent.pageY - window.scrollY) /$(window).height()
    const origin = {x, y}
    fireDefault(count, {origin})
  }
}

export const confettiOnContainer = exportDefault.confettiOnContainer = async (container, options) => {
  const canvas = options || {css: {position: 'fixed'}}
  const customConfetti = custom(container, null, {canvas})
  await fireUntil(customConfetti, () => true)
}

export default exportDefault
